﻿'use strict';

angular.module('ntmApp').factory('Animation', ['UserInfo', 'Utils', 'ListGridHelper',
    function (UserInfo, Utils, ListGridHelper) {

    function Animation(userData) {

        var self = this;
        var columnAnimations = new Map();
        var sectionAnimations = new Map();
        var tabAnimations = new Map();
        var gridAnimations = new Map();

        var model = null;
        var pageLevelAnimation = false;

        self.data = [];

        self.setModel = function (m) {
            model = m;
        };

        self.setAnimationLevel = function (val) {
            pageLevelAnimation = val === 'page' ? true : false;
        };

        self.initAnimation = function (animationObj) {
            animationObj = JSON.parse(animationObj);
            if (animationObj && animationObj.length > 0) {
                animationObj.forEach(function (animation) {
                    if (animation.sections && animation.sections.length > 0) {
                        buildSectionAnimation(animation);
                    } else if (animation.tabs && animation.tabs.length > 0) {
                        buildTabAnimation(animation);
                    } else if (animation.grids && animation.grids.length > 0) {
                        buildGridAnimation(animation);
                    } else {
                        animation.fields.forEach(function (field) {
                            columnAnimations.set(field, animation);
                        });
                    }
                });
            }
        };

        self.getAnimatedObject = function (fieldName) {
            return columnAnimations.get(fieldName);
        };

        self.performDialogAnimation = function (field) {
            var animationMap = columnAnimations.get(field.fieldName || field.templateOptions.fieldName);
            if (animationMap) {
                performDialogAnimation(field, animationMap);
            }
        };

        self.performDisableAnimation = function (row, col) {
            var animationMap = columnAnimations.get(col.name);
            if (animationMap) {
                if (row.hiddenColumns) {
                    row.hiddenColumns[col.name] = performDisableAnimation(row, animationMap);
                }
                return performDisableAnimation(row, animationMap);
            }

            return false;
        };

        self.performInlineAnimation = function (row, options) {
            columnAnimations.forEach(function (animationMap) {
                animationMap.fields.forEach(function (field) {
                    performInlineAnimation(row, animationMap, field, options);
                });
            });
        };

        self.performSectionAnimation = function (sectionID) {

            if (sectionAnimations.get(sectionID)) {
                return eval(sectionAnimations.get(sectionID)); // jshint ignore:line
            }

            return true;
        };

        self.performTabAnimation = function (tabID) {

            if (tabAnimations.get(tabID)) {
                return eval(tabAnimations.get(tabID)); // jshint ignore:line
            }

            return true;
        };

        self.performGridAnimation = function (gridData) {

            var animationObj = gridAnimations.get(gridData.sectionId);

            if (!animationObj) {
                return;
            }
            
            animationObj.forEach(function (animationData) {
                if (!animationData || !eval(animationData.condition)) {// jshint ignore:line
                    return;
                }

                animationData.fields.forEach(function (field) {
                    var gridColumn = _us.find(gridData.columns, function (col) { return col.fieldName === field; });
                    gridColumn.isHide = true;
                });
            });
        };

        function buildSectionAnimation(animation) {

            animation.sections.forEach(function (section) {
                if (animation.show || animation.hide) {
                    var condition = buildConditions(animation.show || animation.hide, 'model');
                    if (animation.hide) {
                        condition = '!({0})'.format(condition);
                    }
                    sectionAnimations.set(section, condition);
                }
            });
        }

        function buildTabAnimation(animation) {

            animation.tabs.forEach(function (tab) {
                if (animation.show || animation.hide) {
                    var condition = buildConditions(animation.show || animation.hide, 'model');
                    if (animation.hide) {
                        condition = '!({0})'.format(condition);
                    }
                    tabAnimations.set(tab, condition);
                }
            });
        }

        function buildGridAnimation(animation) {

            animation.grids.forEach(function (grid) {

                var animationData = [];

                grid.conditions.forEach(function (conditionObj) {
                    if (conditionObj.show || conditionObj.hide) {
                        var condition = buildConditions(conditionObj.show || conditionObj.hide, 'model');
                        if (conditionObj.show) {
                            condition = '!({0})'.format(condition);
                        }

                        animationData.push({ condition: condition, fields: conditionObj.fields });
                    }                    
                });

                gridAnimations.set(grid.sectionId, animationData);
            });
        }

        function performDialogAnimation(field, animationObj) {
            var condition = '';

            if (!field.expressionProperties) {
                field.expressionProperties = {};
            }

            if (animationObj.show && animationObj.show.length > 0) {
                condition = buildConditions(animationObj.show, 'model');
                field.hideExpression = '!(' + condition + ')';
            }

            if (animationObj.hide && animationObj.hide.length > 0) {
                condition = buildConditions(animationObj.hide, 'model');
                field.hideExpression = condition;
            }

            if (animationObj.enable && animationObj.enable.length > 0) {
                condition = buildConditions(animationObj.enable, 'model');
                field.expressionProperties['templateOptions.disabled'] = '!(' + condition + ')';
            }

            if (animationObj.disable && animationObj.disable.length > 0) {
                condition = buildConditions(animationObj.disable, 'model');
                field.expressionProperties['templateOptions.disabled'] = condition;
            }

            if (animationObj.dropdownOptions && animationObj.dropdownOptions.length > 0) {
                var conditionList = [];
                var options = field.templateOptions.options;
                var column = ListGridHelper.getColumnByFieldName(field.templateOptions.fieldName);

                if (!column) {
                    return;
                }

                animationObj.dropdownOptions.forEach(function (item) {
                    conditionList.push({ values: item.values, condition: buildConditions(item.conditions, 'model') });
                });

                field.expressionProperties['templateOptions.options'] = function () {
                    var result = options;
                    conditionList.forEach(function (item) {
                        var values = item.values.map(function (val) { return { name: val, value: val }; });
                        if (eval(item.condition)) { // jshint ignore:line
                            result = values;
                        }
                    });

                    return result;
                };
            }

            if (animationObj.set && animationObj.set.length > 0) {
                var conditionSetList = [];

                animationObj.set.forEach(function (item) {
                    conditionSetList.push({ value: item.value, condition: buildConditions(item.conditions, 'model') });
                });

                field.expressionProperties.model = function () {
                    conditionSetList.forEach(function (item) {
                        if (eval(item.condition)) { // jshint ignore:line
                            model[field.key] = column ? convertValueToType(column.type, item.value) : item.value;
                        } else {
                            //model[field.key] = null;
                        }
                    });
                };
            }
        }

        function performDisableAnimation(row, animationObj) {
            var condition = '';

            if (animationObj.show && animationObj.show.length > 0 || animationObj.enable && animationObj.enable.length > 0) {
                condition = buildConditions(animationObj.show || animationObj.enable, 'row.entity');
                return !eval(condition); // jshint ignore:line
            }

            if (animationObj.hide && animationObj.hide.length > 0 || animationObj.disable && animationObj.disable.length > 0) {
                condition = buildConditions(animationObj.hide || animationObj.disable, 'row.entity');
                return eval(condition); // jshint ignore:line
            }            
        }

        function performInlineAnimation(row, animationObj, field, options) {
            var column = ListGridHelper.getColumnByFieldName(field);

            if (animationObj.dropdownOptions && animationObj.dropdownOptions.length > 0) {
                var conditionList = [];

                if (self.data) {
                    options[column.name] = angular.copy(self.data[column.name]);
                }

                animationObj.dropdownOptions.forEach(function (item) {
                    conditionList.push({ values: item.values, condition: buildConditions(item.conditions, 'row') });
                });

                conditionList.forEach(function (item) {
                    if (eval(item.condition)) { // jshint ignore:line
                        options[column.name] = item.values;
                    }
                });
            }

            if (animationObj.set && animationObj.set.length > 0) {
                var conditionSetList = [];

                animationObj.set.forEach(function (item) {
                    conditionSetList.push({ value: item.value, condition: buildConditions(item.conditions, 'row') });
                });

                conditionSetList.forEach(function (item) {
                    if (eval(item.condition)) { // jshint ignore:line
                        row[column.name] = convertValueToType(column.type, item.value);
                    } else {
                        //row[column.name] = null;
                    }
                });
            }            
        }

        function buildConditions(conditions, modelName) {
            var result = '';
            conditions.forEach(function (condition) {
              
                if (condition.andor && condition.andor === 'and') {
                    result += '&&';
                }

                if (condition.andor && condition.andor === 'or') {
                    result += '||';
                }

                if (condition.paren && condition.paren === '(') {
                    result += '(';
                }

                if (condition.fieldSource && condition.fieldSource === 'userSession' && userData) {
                    var propertyVal = Utils.GetPropertyByPath(userData, condition.field);
                    if (propertyVal && propertyVal.toString() === condition.value.toString()) {
                        result += 'true';
                    } else {
                        result += 'false';
                    }
                }
                var column = ListGridHelper.getColumnByFieldName(condition.field);

                if (column) {

                    var columnName = pageLevelAnimation ? column.fieldName : column.name;

                    condition.operator = condition.operator || '=';

                    switch (condition.operator) {
                        case '=': case 'equals':
                            result += getCondition(modelName, column.type, columnName, condition.value, '==');
                            break;

                        case 'notEqualTo': case 'not equal': case 'not equal to': case '!=':
                            result += getCondition(modelName, column.type, columnName, condition.value, '!=');
                            break;

                        case 'lessThan': case 'less than': case '<':
                            result += getCondition(modelName, column.type, columnName, condition.value, '<');
                            break;

                        case 'greaterThan': case 'greater than': case '>':
                            result += getCondition(modelName, column.type, columnName, condition.value, '>');
                            break;

                        case 'lessThanOrEquals': case 'less than or equal to': case 'lessThanOrEqualTo': case '<=':
                            result += getCondition(modelName, column.type, columnName, condition.value, '<=');
                            break;

                        case 'greaterThanOrEquals': case 'greater than or equal to': case '>=':
                            result += getCondition(modelName, column.type, columnName, condition.value, '>=');
                            break;

                        case 'startsWith': case 'starts with': case 'StartWith':
                            result += modelName + '.' + columnName + '!=null&&' + modelName + '.' + columnName + '!=""&&' + modelName + '.' + columnName + '.startsWith("' + condition.value + '")';
                            break;

                        case 'contains':
                            result += modelName + '.' + columnName + '!=null&&' + modelName + '.' + columnName + '!=""&&' + modelName + '.' + columnName + '.indexOf("' + condition.value + '")!==-1';
                            break;

                        case 'in': case 'inList':
                            result += '"' + condition.value + '"' + '.indexOf(' + modelName + '.' + columnName + ')!=-1';
                            break;

                        case 'not in': case 'notIn': case 'notInList':
                            result += '"' + condition.value + '"' + '.indexOf(' + modelName + '.' + columnName + ')==-1';
                            break;

                        case 'is null': case 'isNull':
                            result += modelName + '.' + columnName + '==null&&' + modelName + '.' + columnName + '==""';
                            break;

                        case 'is not null': case 'isNotNull':
                            result += modelName + '.' + columnName + '!=null&&' + modelName + '.' + columnName + '!=""';
                            break;

                        case 'between':
                            if (column.type === 'DATE') {
                                result += modelName + '.' + columnName + '!=null&&' + modelName + '.' + columnName + '!=""' + '&&' + modelName + '.' + columnName + '.getTime()' + '>' + 'new Date("' + condition.value + '").getTime()' + '&&' + modelName + '.' + columnName + '.getTime()' + '<' + 'new Date("' + condition.highValue + '").getTime()';
                            } else {
                                result += modelName + '.' + columnName + '>' + condition.value + ' && ' + modelName + '.' + columnName + '<' + condition.highvalue;
                            }
                            break;
                    }
                }

                if (condition.paren && condition.paren === ')') {
                    result += ')';
                }

            });

            return result === '' ? true : result;

        }

        function getCondition(modelName, type, name, value, operator) {
            var result = modelName + '.' + name + operator + '"' + value + '"';
            switch (type) {
                case 'DATE':
                    result = modelName + '.' + name + '!=null&&' + modelName + '.' + name + '!=""' + '&&' + modelName + '.' + name + '.getTime()' + operator + 'new Date("' + value + '").getTime()';
                    break;

                case 'CHECKBOXLIST':
                    result = modelName + '.' + name + '!=null&&' + modelName + '.' + name + '!=""' + '&&' + modelName + '.' + name + '.lenfth>0&&' + modelName + '.' + name + '.filter(function(item){return item.id ' + operator + '"' + value + '";}).length>0';
                    break;

                case 'CHECKBOX':
                    result = value === true ? modelName + '.' + name : '!' + modelName + '.' + name;
                    break;
            }

            return result;
        }

        function convertValueToType(type, value) {
            var val = value;
            switch (type) {
                case 'CHECKBOXLIST':
                    val = [{ id: value }];
                    break;

                case 'NUMERIC':
                    val = parseFloat(value);
                    break;

                case ('DATE'):
                    val = new Date(value);
                    break;

                case ('TIME'):
                    var time = value.split(':');
                    val = new Date(moment({ hour: parseInt(time[0]), minute: parseInt(time[1]) }));
                    break;

            }

            return val;
        }

    }

    return (Animation);
}]);